export enum PortalActionType {
    DOWNLOAD_PREVIEW = 'DOWNLOAD_PREVIEW',
    DOWNLOAD = 'DOWNLOAD',
    WATCH = 'WATCH',
    SHARE = 'SHARE',
    OPEN_IN_VIEWER = 'OPEN_IN_VIEWER',
    CONTACT_ADMIN = 'CONTACT_ADMIN'
}

// This is the order in which the items appear
export const GENERIC_RECORD_ACTION_TYPES: readonly PortalActionType[] = [
    PortalActionType.WATCH,
    PortalActionType.DOWNLOAD_PREVIEW,
    PortalActionType.DOWNLOAD,
    PortalActionType.SHARE,
    PortalActionType.OPEN_IN_VIEWER,
    PortalActionType.CONTACT_ADMIN
];

export const PORTAL_ICON_ACTIONS: readonly PortalActionType[] = [
    PortalActionType.DOWNLOAD_PREVIEW,
    PortalActionType.DOWNLOAD,
    PortalActionType.SHARE
];
export const PORTAL_ICONLESS_ACTIONS: readonly PortalActionType[] = [
    PortalActionType.WATCH,
    PortalActionType.OPEN_IN_VIEWER,
    PortalActionType.CONTACT_ADMIN
];
